export default __webpack_public_path__ + "static/media/vielleicht_beim_dritten_date_cover.dc5d962b.webp";